ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_review_list'] = require '../../review_list.html.mustache'
ProductReviews.Views.ReviewCard = require './product_reviews_review_card'
ProductReviews.Views.ReviewRating = require './product_reviews_review_rating'

ProductReviews.Views.ReviewList = Backbone.View.extend
  el: "#product-reviews-list"

  render: ->
    fetchedReviews = @collection.fetchedReviews()
    if @collection.page is 1
      @$el.html ProductReviews.Templates['product_reviews_review_list'].render(reviews: _.pluck fetchedReviews, 'attributes')
    else
      @$el.append ProductReviews.Templates['product_reviews_review_list'].render(reviews: _.pluck fetchedReviews, 'attributes')

    for review in fetchedReviews
      (new ProductReviews.Views.ReviewCard model: review, el: "#review-card-#{review.id}").render()
      (new ProductReviews.Views.ReviewRating model: review, el: "#review-rating-#{review.id}").render()


module.exports = ProductReviews.Views.ReviewList
